/**
 * Страница менеджера: проект пользователя (manager/userproject).
 *
 * Маркер инициализации — наличие #managerNoteForm.
 * Конфиг — window.managerUserProjectConfig.
 *
 * Функционал:
 *   - сохранение manager_note;
 *   - открытие модалки файлов проекта;
 *   - debounced auto-save привязки менеджеров (для super-manager).
 */

function init() {
    if (!document.getElementById('managerNoteForm')) return;

    const config = window.managerUserProjectConfig;
    if (!config) {
        console.error('[manager-user-project] window.managerUserProjectConfig not found');
        return;
    }

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-user-project] jQuery not loaded');
        return;
    }
    const showToast = window.showToast || function () {};
    const showLargeModal = window.showLargeModal || function () {};

    $(() => {
        // Сохранение комментария менеджера
        $('#saveNoteBtn').on('click', function (e) {
            e.preventDefault();
            $.ajax({
                url: config.routes.saveNote,
                type: 'POST',
                data: {
                    _token: config.csrfToken,
                    manager_note: $('#manager_note').val(),
                },
                success(response) {
                    if (response.success) {
                        showToast('success', 'Manager note saved successfully');
                        $('#saveNoteBtn').addClass('btn_success');
                        setTimeout(() => $('#saveNoteBtn').removeClass('btn_success'), 2000);
                    } else {
                        showToast('error', response.message || 'Failed to save note');
                    }
                },
                error() {
                    showToast('error', 'Error saving note');
                },
            });
        });

        // Открытие модалки файлов проекта
        $('#filesBtn').on('click', function (e) {
            e.preventDefault();
            showLargeModal('projectFilesModal');
        });

        // Auto-save привязки менеджеров (super-manager only)
        let saveTimeout;
        $('.manager-checkbox').on('change', function () {
            clearTimeout(saveTimeout);
            saveTimeout = setTimeout(() => {
                const selectedManagers = [];
                $('.manager-checkbox:checked').each(function () {
                    selectedManagers.push($(this).val());
                });

                $.ajax({
                    url: config.routes.assignManagers,
                    type: 'POST',
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        manager_ids: selectedManagers,
                    },
                    success(response) {
                        if (response.success) {
                            showToast('success', 'Managers updated successfully');
                        } else {
                            showToast('error', 'Error: ' + (response.message || 'unknown'));
                        }
                    },
                    error() {
                        showToast('error', 'Error updating managers');
                    },
                });
            }, 800);
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
